/**
 * 辅助工具函数
 */

/**
 * 为组件添加安装方法
 * @param {Object} Mod Vue组件
 * @param {Object} props
 * @return {Object}
 */
export function install (Mod, props = {}) {
  Mod.install = Vue => Vue.component(Mod.name, Mod);
  Object.assign(Mod, props);
  return Mod;
}

/**
 * 代理内部组件方法
 * @param {string[]} names 需要代理的方法名称数组
 * @param {string} refName 内部组件的引用名称
 * @returns {Object}
 */
export function proxyMethods (names = [], refName) {
  const methods = {};
  names.forEach(name => {
    methods[name] = function () {
      const vm = this.$refs[refName] || {};
      const func = vm[name];
      func && func.apply(vm, arguments);
    };
  });
  return methods;
}
